const nl = {
    splash: {
        start: {
            helper: 'Druk op de knop om te beginnen',
            button: 'Start bestelling'
        },
        banner: {
            title: 'Welkom bij {ORGANISATION}!',
            content: 'Op deze zelfservice kiosk kun je eenvoudig zelf je entreeticket(s) bestellen.'
        }
    },
    catalog: {
        loading: 'Bezig met laden...',
        tabs: {
            ongoing: 'Huidige',
            all: 'Alles'
        },
        items: {
            select: 'Selecteren',
            empty: 'Geen aankomende evenementen!'
        }
    },
    cart: {
        title: 'Mijn reservering',
        empty: 'Nog geen tickets in je reservering!',
        items: {
            tickets: 'Tickets',
            date: 'Datum',
            time: 'Tijd'
        },
        total: 'Totaalbedrag',
        buttons: {
            checkout: 'Afrekenen',
            cancel: 'Annuleren'
        }
    },
    booking: {
        steps: {
            quantity: {
                title: 'Ticket aantallen'
            },
            upsell: {
                title: 'Toevoegingen voor je bestelling'
            },
            plot: {
                title: 'Reservering',
                empty: 'Er zijn geen boekmomenten beschikbaar.',
                now: 'Je hebt het boekmoment gekozen om nu entree te krijgen.',
                change: 'Wijzigen'
            }
        },
        buttons: {
            continue: 'Doorgaan',
            return: 'Terug',
            cancel: 'Annuleren'
        }
    },
    checkout: {
        loading: 'Bezig met laden...',
        steps: {
            payment: 'Rond de betaling af op het pinapparaat...',
            acts: {
                payment: 'Rond de betaling af via pin of cash...',
                paymentLeft: 'Je moet nog {paymentLeft} betalen',
                cancel: 'Annuleren',
            },
            tickets: 'Betaling geslaagd! Neem de tickets uit...',
            tickets_info: 'Wil je ook een PIN-bon ontvangen?',
            receipt: 'Neem de bon uit...',
            receipt_info: 'Je PIN-bon is uitgeprint.',
            failures: {
                transaction: {
                    title: 'De betaling is niet voltooid!',
                    description: 'Je kunt proberen de transactie overnieuw uit te voeren.'
                },
                print: {
                    title: 'Tickets en bon konden niet geprint worden!',
                    description: 'Vraag een medewerker de printer na te kijken, hierna zullen alsnog je tickets inclusief PIN-bon geprint worden.'
                }
            },
            error: 'Bestelling kon niet worden geplaatst!'
        },
        buttons: {
            retry: 'Opnieuw proberen',
            cancel: 'Terug',
            next: 'Volgende klant',
            yes: 'Ja',
            yes_info: 'Ik wil een bon!',
            no: 'Nee',
            no_info: 'Geen bon nodig!',
            reprint_tickets: 'Tickets opnieuw printen',
            reprint_tickets_countdown: 'Tickets opnieuw printen ({seconds}s)'
        }
    },
    errors: {
        audience_not_found: 'De doelgroep is niet gevonden.',
        captcha_invalid: 'De CAPTCHA is ongeldig, herlaad de pagina en bestel opnieuw.',
        coupon_expired: 'Deze coupon is verlopen.',
        coupon_invalid: 'Opgegeven coupon code is niet geldig.',
        coupon_product_mismatch: 'Deze coupon kan niet voor dit product gebruikt worden.',
        coupon_redemptions_exceeded: 'Deze coupon is volledig verbruikt.',
        customer_field_invalid: 'Een formulier veld is onjuist ingevuld, controleer je gegevens.',
        customer_field_missing: 'Een formulier veld ontbreekt, controleer je gegevens.',
        customer_token_invalid: 'Klant sleutel is niet geldig, gelieve opnieuw in te loggen.',
        customer_token_required: 'Dit emailadres is reeds geregistreerd, gelieve in te loggen alvorens een bestelling te plaatsen.',
        plot_capacity_insufficient: 'Het boekmoment dat je probeert te bestellen heeft geen capaciteit meer, selecteer een ander moment.',
        plot_not_found: 'Het boekmoment dat je probeert te bestellen is niet meer beschikbaar.',
        product_max_quantity_exceeded: 'Het aantal tickets is boven de maximale afname, verlaag je aantallen.',
        product_min_quantity_exceeded: 'Het aantal tickets is onder de minimale afname, verhoog je aantallen.',
        product_not_found: 'Het product dat je probeert te bestellen is niet meer beschikbaar.',
        rebook_invalid: 'De omboeking is niet geldig.',
        rebook_product_mismatch: 'De omboeking kan niet met opgegeven product.',
        subscription_expired: 'Het abonnement is verlopen.',
        subscription_inactive: 'Het abonnement is niet meer actief, waarschijnlijk is de capaciteit onvoldoende.',
        subscription_invalid: 'Het abonnement is niet geldig.',
        subscription_not_found: 'Opgegeven abonnement kan niet gevonden worden.',
        subscription_product_mismatch: 'Het abonnement geeft geen toegang tot dit product.',
        subscription_quantity_mismatch: 'Het abonnement geeft geen toegang tot deze aantallen.',
        subscription_redemptions_exceeded: 'Het abonnement heeft zijn maximale verbruik overschreden.',
        subscription_used_today: 'Het abonnement is vandaag al gebruikt.',
        upsell_not_allowed: 'Deze upsell kan niet besteld worden in combinatie met dit product.',
        upsell_not_found: 'De upsell is niet gevonden.'
    },
    printer: {
        title: 'Fout met printer opgetreden!',
        reload: 'Opnieuw proberen',
        errors: {
            paper_empty: 'Papier is bijna op.',
            cover_open: 'De klep is geopend.',
            device_offline: 'Kan geen verbinding worden gemaakt.',
            device_malfunction: 'Er is een algemene fout.'
        }
    }
}

export default nl;
